module.exports = __webpack_public_path__ + "static/img/liucheng@2x.deb7c58.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/shopIntr/shop/liucheng@2x.png
// module id = mzgY
// module chunks = 18